import React from 'react';
import EntityTableRow from './EntityTableRow';

function headerAlignClass(align) {
  if (align === 'right') return 'text-right';
  if (align === 'center') return 'text-center';
  return 'truncate';
}

export default function EntityTable({
  title,
  description,
  columns,
  rows,
  getRowKey,
  getRowVariant,
  maxRows,
  className = '',
}) {
  if (!Array.isArray(columns) || columns.length === 0) return null;
  if (!Array.isArray(rows) || rows.length === 0) return null;

  const limited = typeof maxRows === 'number' ? rows.slice(0, maxRows) : rows;
  const total = columns.reduce((sum, c) => sum + (c?.colSpan || 1), 0);

  return (
    <div className={`mt-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3 ${className}`}>
      {title ? (
        <div className="text-xs tracking-wide text-white/60 font-semibold">{title}</div>
      ) : null}
      {description ? (
        <div className="mt-0.5 text-[11px] text-white/55">{description}</div>
      ) : null}

      <div
        className="mt-3 grid gap-3 text-[10px] uppercase tracking-wider text-white/45"
        style={{ gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))` }}
      >
        {columns.map((c) => {
          const span = c?.colSpan && c.colSpan > 1 ? c.colSpan : null;
          return (
            <div
              key={c.key}
              className={headerAlignClass(c?.align)}
              style={span ? { gridColumn: `span ${span} / span ${span}` } : undefined}
            >
              {c?.label}
            </div>
          );
        })}
      </div>

      <div className="mt-2 space-y-2">
        {limited.map((row, idx) => (
          <EntityTableRow
            key={getRowKey ? getRowKey(row, idx) : idx}
            row={row}
            idx={idx}
            columns={columns}
            totalCols={total}
            variant={getRowVariant ? getRowVariant(row, idx) : 'default'}
          />
        ))}
      </div>
    </div>
  );
}
